import { ObserversModule } from '@angular/cdk/observers';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';

import { DropdownDividerComponent } from './components/dropdown-divider/dropdown-divider.component';
import { DropdownHeaderComponent } from './components/dropdown-header/dropdown-header.component';
import { DropdownItemComponent } from './components/dropdown-item/dropdown-item.component';
import { DropdownMenuComponent } from './components/dropdown-menu/dropdown-menu.component';
import { DropdownDirective } from './directives/dropdown.directive';

@NgModule({
  imports: [
    CommonModule,
    IconsModule,
    PopoverModule,
    OverlayModule,
    ObserversModule,
  ],
  declarations: [
    DropdownMenuComponent,
    DropdownItemComponent,
    DropdownHeaderComponent,
    DropdownDividerComponent,
    DropdownDirective,
  ],
  exports: [
    DropdownDirective,
    DropdownMenuComponent,
    DropdownItemComponent,
    DropdownHeaderComponent,
    DropdownDividerComponent,
  ],
})
export class DropdownModule {}
